<template>
  <div class="loginContainer">
    <v-snackbar
      top
      :color="snackbarColor"
      :timeout="3000"
      absolute
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >
    <div class="bg">
      <video src="~@/assets/bg1.mp4" autoplay muted loop></video>
    </div>
    <div class="d-none d-sm-none d-md-block d-xl-block">
      <transition name="appear-far" appear>
        <div class="sideBar">
          <!-- <svg
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.20993 25.1583C9.45901 26.6345 12.0905 27.421 14.7808 27.4212L14.7473 27.4373C15.8507 27.434 16.9496 27.2975 18.0203 27.0309C18.1293 27.0048 18.2384 26.9776 18.345 26.9478C20.1381 26.4603 21.815 25.6174 23.2761 24.4692C24.8965 23.1609 26.1685 21.4726 26.9791 19.5542C28.2655 16.5117 28.3634 12.8819 27.1192 9.80593C26.7852 8.98593 26.3511 8.21043 25.8266 7.49712L25.8179 7.48597C24.909 6.27643 23.6941 5.33103 22.2983 4.74713C22.2202 4.71243 22.1385 4.68021 22.0579 4.65047C21.5978 4.47809 21.1228 4.34866 20.6389 4.26381C20.019 4.15461 19.3885 4.1176 18.7601 4.15351H18.7539C18.5891 4.16219 18.433 4.17706 18.2768 4.19441C15.1575 4.51167 13.2465 6.22437 12.5562 7.17863C12.4385 7.34097 12.2762 7.83049 12.5699 8.206C12.6659 8.34125 12.8014 8.4435 12.9578 8.49875C13.1142 8.55399 13.2839 8.55952 13.4436 8.51458C15.1414 7.99284 17.2333 8.43155 18.7044 10.0389C19.3799 10.7775 19.8307 11.6934 20.004 12.6792C20.1772 13.665 20.0656 14.6797 19.6823 15.6043C19.2989 16.5289 18.6598 17.325 17.8399 17.8991C17.02 18.4731 16.0533 18.8014 15.0534 18.8453H14.5825C13.3516 18.7896 12.1836 18.2858 11.2984 17.4288C8.55456 14.8151 8.39841 10.257 9.98718 7.01876C10.1235 6.72876 10.2735 6.44992 10.4333 6.18223C10.4333 6.18223 12.0816 3.4719 15.1426 2.37017C15.1426 2.37017 15.6768 2.1756 16.0325 2.09009C16.3881 2.00458 16.693 1.65138 16.6521 1.26348C16.6013 0.795027 16.3733 0.526101 15.8862 0.414564C15.6012 0.348882 14.927 0.357556 14.6308 0.357556C11.0503 0.356167 7.6129 1.76354 5.06142 4.27559C2.50995 6.78764 1.04923 10.2027 0.994873 13.7828C1.01798 16.0434 1.59714 18.2636 2.68125 20.2475C3.76535 22.2314 5.32108 23.9179 7.21116 25.1583H7.20993ZM17.3114 7.7078C16.2109 8.07959 15.129 7.80571 14.8923 7.07824C14.8852 7.06306 14.8809 7.04666 14.8799 7.02991C14.6891 6.31608 15.4004 5.48699 16.486 5.14495C17.532 4.80786 18.5408 5.02102 18.8531 5.65305C18.8734 5.69289 18.8904 5.73434 18.9039 5.77698C19.1406 6.50197 18.4156 7.36824 17.3151 7.71648L17.3114 7.7078ZM20.8632 7.44135C20.5992 7.47977 20.3675 7.36824 20.3415 7.20217C20.3323 7.15468 20.3416 7.10546 20.3675 7.06461C20.4118 6.99493 20.4714 6.93635 20.5419 6.89338C20.6124 6.8504 20.6918 6.82419 20.774 6.81675C20.8521 6.80177 20.9325 6.80329 21.0099 6.82122C21.0874 6.83914 21.1603 6.87308 21.2238 6.92085C21.2626 6.95632 21.2879 7.004 21.2957 7.05593C21.3131 7.222 21.1321 7.40542 20.8632 7.44135ZM19.3488 5.70634C19.3463 5.68576 19.3463 5.66496 19.3488 5.64438C19.3637 5.27259 19.8321 4.99127 20.391 4.99127H20.4976C20.6786 4.99324 20.8571 5.03332 21.0215 5.10891C21.1859 5.1845 21.3326 5.29391 21.4519 5.42998C21.5307 5.53328 21.5679 5.66244 21.556 5.79186C21.5114 6.1971 21.0231 6.46975 20.4072 6.43133C19.8222 6.38672 19.3723 6.05954 19.3488 5.70263"
              fill="#FF1744"
            />
          </svg> -->
          <img src="../assets/Dilo Cargo SVG.svg" width="300px" alt="">
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            style="width: 300px"
            viewBox="0 0 473.79 132.7"
          >
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  class="cls-1"
                  d="M164.42,94A37.72,37.72,0,0,1,153,66.19a37.69,37.69,0,0,1,11.44-27.77Q175.87,27,194.64,27a40.75,40.75,0,0,1,14.59,2.39,50.16,50.16,0,0,1,10,5.32,3.5,3.5,0,0,1,1.12,4.58l-3.6,6.62a3.49,3.49,0,0,1-4.92,1.31A31.45,31.45,0,0,0,194.75,42q-11.3,0-18,6.89A23.74,23.74,0,0,0,170,66.19a23.78,23.78,0,0,0,6.73,17.31q6.72,6.89,18,6.89a31.46,31.46,0,0,0,17.12-5.25,3.49,3.49,0,0,1,4.92,1.31l3.6,6.62a3.5,3.5,0,0,1-1.12,4.58,50.16,50.16,0,0,1-10,5.32,40.75,40.75,0,0,1-14.59,2.39Q175.86,105.36,164.42,94Z"
                />
                <path
                  class="cls-1"
                  d="M275,48.51h9.15a3.51,3.51,0,0,1,3.51,3.5v48.65a3.51,3.51,0,0,1-3.51,3.5H275a3.51,3.51,0,0,1-3.51-3.5V96q-6.51,9.33-17.47,9.33-12.36,0-19.74-8.36t-7.38-20.94q0-12.26,7.11-20.5t19.69-8.25A22.16,22.16,0,0,1,263.8,49.7a21,21,0,0,1,7.65,6.4V52A3.51,3.51,0,0,1,275,48.51ZM243,76.17a17.19,17.19,0,0,0,3.85,11.5,13,13,0,0,0,10.47,4.56,14.31,14.31,0,0,0,10.41-4q4.13-4,4.13-11.17,0-7.7-4.13-12.15a14.08,14.08,0,0,0-10.85-4.45,12.48,12.48,0,0,0-10.14,4.5A17,17,0,0,0,243,76.17Z"
                />
                <path
                  class="cls-1"
                  d="M317.24,52v8.65q1.18-6.73,6-10a16.48,16.48,0,0,1,9.33-3.31l.72,0a3.53,3.53,0,0,1,3.41,3.51v8.74a3.52,3.52,0,0,1-3.89,3.48c-1-.08-1.94-.12-2.95-.12a13.29,13.29,0,0,0-8.57,2.87,9.77,9.77,0,0,0-3.58,8.08v26.77a3.5,3.5,0,0,1-3.5,3.5H305a3.51,3.51,0,0,1-3.51-3.5V52a3.51,3.51,0,0,1,3.51-3.5h8.72A3.51,3.51,0,0,1,317.24,52Z"
                />
                <path
                  class="cls-1"
                  d="M398.57,48.51a3.51,3.51,0,0,1,3.51,3.5v48.25q0,15.51-8.57,23t-21.59,7.49q-14.76,0-23.74-5.79a3.54,3.54,0,0,1-1.28-4.57l3.23-6.35a3.53,3.53,0,0,1,4.92-1.43,35.54,35.54,0,0,0,4.44,2.13,24.45,24.45,0,0,0,9.17,2q17.25,0,17.25-14.65V96q-6.51,9.33-17.46,9.33-12.37,0-19.75-8.36t-7.38-20.94q0-12.26,7.11-20.5t19.69-8.25a22.13,22.13,0,0,1,10.14,2.39,21,21,0,0,1,7.65,6.4V52a3.51,3.51,0,0,1,3.51-3.5ZM357.49,76.17a17.19,17.19,0,0,0,3.85,11.5,13,13,0,0,0,10.47,4.56,14.31,14.31,0,0,0,10.41-4q4.13-4,4.13-11.17,0-7.7-4.13-12.15a14.08,14.08,0,0,0-10.85-4.45,12.51,12.51,0,0,0-10.14,4.5A17,17,0,0,0,357.49,76.17Z"
                />
                <path
                  class="cls-1"
                  d="M421.66,97.17a26.92,26.92,0,0,1-9.06-20.89q0-12.69,9.06-20.83a32.48,32.48,0,0,1,43.07,0,26.81,26.81,0,0,1,9.06,20.78,26.92,26.92,0,0,1-9.06,20.89,32.41,32.41,0,0,1-43.07,0Zm6.67-20.89a14.62,14.62,0,0,0,4.4,10.85,14.4,14.4,0,0,0,10.47,4.34,14.23,14.23,0,0,0,10.52-4.39,14.79,14.79,0,0,0,4.34-10.8,14.59,14.59,0,0,0-4.34-10.74,14.86,14.86,0,0,0-21,0A14.49,14.49,0,0,0,428.33,76.28Z"
                />
                <path
                  class="cls-1"
                  d="M30.57,121.38A68.77,68.77,0,0,0,67.92,132.7h0a55,55,0,0,0,16.42-2.26,2.08,2.08,0,0,0,1.7-.57c9-2.26,17-6.79,24.33-12.45a60,60,0,0,0,18.12-24.34c6.22-15.28,6.79-32.83.56-48.11a72.8,72.8,0,0,0-6.22-11.32h0a41.09,41.09,0,0,0-17.55-13.59c-.57,0-.57-.56-1.13-.56a15,15,0,0,0-6.79-1.7,48.39,48.39,0,0,0-9.06-.57H86C70.75,18.93,61.13,27.42,57.73,32a5.3,5.3,0,0,0,0,5.09c0,1.7.57,1.7,1.14,2.27.56,0,1.69.56,2.26,0,8.49-2.83,18.68-.57,26,7.36a21.7,21.7,0,0,1,6.22,13A20.3,20.3,0,0,1,91.7,73.83a25.32,25.32,0,0,1-9.06,11.32,24.4,24.4,0,0,1-13.59,4.53H66.79c-6.23,0-11.89-2.83-16.41-6.79-13.59-13-14.15-35.09-6.23-51.51,1.13-.56,1.7-2.26,2.26-3.39,0,0,7.93-13.59,23.21-18.68a16.51,16.51,0,0,1,4.53-1.13c1.7-.57,3.39-2.27,2.83-4C77,2,75.85.82,73,.25c-1.14-.56-4.53,0-6.23,0-17-1.13-34,5.66-47,18.11A67,67,0,0,0,0,65.34,61.88,61.88,0,0,0,8.49,97c5.09,10.19,13,18.11,22.08,24.34Zm49.81-86c-5.67,1.7-10.76.57-11.89-2.83h0c-1.13-3.39,2.83-7.35,7.92-9s10.19-.57,11.89,2.26v.57c1.13,3.39-2.26,7.36-7.92,9.05Zm17.54-1.13a4.32,4.32,0,0,1-2.83-1.13v-.57c0-.56.57-.56,1.13-.56s.57-.57,1.14-.57h1.13c.56,0,.56,0,1.13.57l.57.56C100.19,33.08,99.05,33.65,97.92,34.21Zm-7.36-8.49h0c0-2.26,2.27-4,5.1-4h.56a5.06,5.06,0,0,1,2.83.57c.57.56,1.7,1.13,2.27,1.69a2.11,2.11,0,0,1,.56,1.7c0,2.27-2.83,3.4-5.66,3.4-3.39,0-5.66-1.7-5.66-3.4"
                />
              </g>
            </g>
          </svg> -->

          <!-- <h1>Envíos Corporativos</h1> -->
        </div>
      </transition>
    </div>
    <div class="loginFormContainer">
      <h1>¡Hola!</h1>
      <p class="d-none d-sm-none d-md-block d-xl-block mt-5">
        Ingresa las credenciales proporcionadas por tu empresa para iniciar.
      </p>

      <form>
        <div class="inputGroup">
          <i class="far fa-user"></i>
          <div class="inputContainer">
            <label for="">Usuario / Correo</label>
            <input autocomplete="username" type="text" v-model="email" />
          </div>
        </div>
        <div class="inputGroup">
          <i class="far fa-key"></i>
          <div class="inputContainer">
            <label for="">Contraseña</label>
            <input
              :type="passwordVisibility ? 'text' : 'password'"
              v-model="password"
              autocomplete="current-password"
              v-on:keyup.enter="login"
            />
          </div>
          <i
            class="far"
            :class="passwordVisibility ? 'fa-eye' : 'fa-eye-slash'"
            @click="passwordVisibility = !passwordVisibility"
          ></i>
        </div>
        <v-btn
          type="button"
          height="55"
          :loading="loading"
          color="primary"
          class="loginBtn"
          @click="login"
        >
          <i class="far fa-sign-in-alt"></i> Ingresar
        </v-btn>
      </form>

      <button class="loginBtn recovPass" @click="passReset">
        <i class="far fa-key"></i> ¿Olvidaste tu Contraseña?
      </button>
      <span class="loginHelp d-none d-md-block d-sm-block d-xl-block"
        >¿problemas para ingresar?, contacta a
        <a
          href="https://api.whatsapp.com/send?phone=50433248888"
          target="_blank"
          >servicio al cliente</a
        ></span
      >
    </div>
    src/assets/POWERED BY DILO DELIVERY.svg
    <div class="loginFooter d-none d-md-block d-sm-block d-xl-block">
      <img width="100" src="@/assets/POWERED BY DILO DELIVERY.svg" alt="">
      <!-- <i class="far fa-copyright"></i> GUIP Servicios Digitales GUIP S.A. -->
    </div>
  </div>
</template>

<script>
import { fb } from "@/firebase";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      passwordVisibility: false,
      email: "",
      password: "",
      valid: true,
      notificationShown: false,
      loading: false,
      snackbarText: "",
      snackbar: false,
      passwordRecoveryDialog: false,
      snackbarColor: "red",
    };
  },
  mounted() {
    this.$store.commit("setNavBar", false);
    this.$store.commit("setLoading", false);
    if (this.$store.state.user) {
      this.$router.push({ path: "/map" }).catch((err) => {});
    }
  },
  created() {},
  methods: {
    login() {
      if (!this.email || !this.password) {
        console.log('no email or password');
        this.snackbarText =
          "Por favor ingresa el correo electrónico y contraseña.";

        this.snackbar = true;

        return
      }

      try {
        this.loading = true;
        fb.auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((response) => {
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;

            switch (error.code) {
              case "auth/invalid-email":
                this.snackbarText =
                  "Por favor ingresa la dirección de correo correctamente";

                break;

              case "auth/user-not-found":
                this.snackbarText =
                  "No existen usuarios con este correo. Verifica tu dirección o ponte en contacto con el administrador.";

                break;

              case "auth/wrong-password":
                this.snackbarText = "Contraseña incorrecta";
                break;

              case "auth/argument-error":
                this.snackbarText =
                  "El correo y la contraseña deben ser campos validos";

                break;
              default:
                this.snackbarText = error.message;
                break;
            }
            this.snackbar = true;
          });
      } catch (error) {
        // console.log(error);
        switch (error.code) {
          case "auth/invalid-email":
            this.snackbarText =
              "Por favor ingresa la dirección de correo correctamente";

            break;

          case "auth/user-not-found":
            this.snackbarText =
              "No existen usuarios con este correo. Verifica tu dirección o ponte en contacto con el administrador.";

            break;

          case "auth/wrong-password":
            this.snackbarText = "Contraseña incorrecta";
            break;

          case "auth/argument-error":
            this.snackbarText =
              "El correo y la contraseña deben ser campos validos";

            break;
          default:
            this.snackbarText = error.message;
            break;
        }
        this.snackbar = true;
        this.snackbarColor = "red darken-2";
      }
    },
    passReset() {
      if (!this.email) {
        this.snackbarText =
          "Debe ingresar una dirección de correo electrónico válida.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";
        return;
      }

      let emailAddress = this.email;
      fb.auth().languageCode = "es";

      try {
        console.log('emailAddress: ', emailAddress);
        fb.auth()
          .sendPasswordResetEmail(emailAddress)
          .then(() => {
            this.snackbarText = "Correo enviado, revisa tu bandeja de entrada";
            this.snackbar = true;
          })
          .catch((error) => {
            console.log(error);
            switch (error.code) {
              case "auth/invalid-email":
                this.snackbarText =
                  "Por favor ingresa la dirección de correo correctamente";

                break;

              case "auth/user-not-found":
                this.snackbarText =
                  "No existen usuarios con este correo. Verifica tu dirección o ponte en contacto con el administrador.";

                break;

              case "auth/wrong-password":
                this.snackbarText = "Contraseña incorrecta";
                break;

              case "auth/argument-error":
                this.snackbarText = "Debes ingresar un correo válido";
                break;
              default:
                this.snackbarText = error.message;
                break;
            }
            this.snackbar = true;
            this.snackbarColor = "red darken-2";
          });
      } catch (error) {
        switch (error.code) {
          case "auth/invalid-email":
            this.snackbarText =
              "Por favor ingresa la dirección de correo correctamente";
            break;

          case "auth/user-not-found":
            this.snackbarText =
              "No existen usuarios con este correo. Verifica tu dirección o ponte en contacto con el administrador.";

            break;

          case "auth/wrong-password":
            this.snackbarText = "Contraseña incorrecta";
            break;

          case "auth/argument-error":
            this.$store.commit(
              "setNotification",
              "Debes ingresar un correo válido"
            );
            break;
          default:
            this.snackbarText = error.message;
            break;
        }
        this.snackbar = true;
        this.snackbarColor = "red darken-2";
      }
    },
  },
};
</script>

<style lang="scss">
.loginContainer {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  video {
    object-fit: cover;
    width: 100%;
    height: 100vh;
  }
}
.loginFormContainer {
  // text-align: left;
  background-color: white;
  margin-left: 35vw;
  width: 30vw;
  min-width: 400px;
  height: 380px;
  border-radius: 25px;
  z-index: 9999;
  color: #111;
  box-sizing: border-box;
  padding: 30px 40px;
  position: relative;
  h1 {
    font-size: 48px;
    font-weight: 900;
  }
  .loginHelp {
    font-size: 12px;
    text-align: center;
    position: absolute;
    bottom: -115px;
    left: 0;
    width: 100%;
    appearance: none;
    border: none;
    outline: none;
    color: white;
    text-decoration: none;
    box-sizing: border-box;
    padding: 5px 20px;
    a {
      color: #FF1744;
      text-decoration: none;
    }
  }
  .loginBtn {
    position: absolute;
    bottom: -21px;
    left: 31px;
    width: calc(100% - 100px);
    appearance: none;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-transform: capitalize;
    text-decoration: none;
    box-sizing: content-box;
    text-align: center;
    padding: 5px 20px;
    // height: 42px;
    line-height: 42px;
    border-radius: 18px;
    transition: 0.3s all;
    color: white;
    background-color: #FF1744;
    cursor: pointer;
    filter: drop-shadow(0px 0px 10px rgba(#FF1744, 0.8));
    &:active {
      filter: drop-shadow(0px 0px 30px rgba(#FF1744, 1));
    }
    &:hover {
      filter: drop-shadow(0px 0px 15px rgba(#FF1744, 0.8));
    }
    &.recovPass {
      bottom: -84px;
      background-color: white;
      color: #333;
      filter: none;
    }
    i {
      // top: 5px;
      left: -10px;
      position: relative;
      display: inline;
      font-size: 28px;
    }
  }
  .inputGroup {
    text-align: left;
    width: 80%;
    position: relative;
    margin: 10px;
    margin-left: 56px;
    // display: flex;
    .address {
      display: block;
      font-size: 12px;
    }
    .coordinates {
      display: block;
      font-size: 12px;
      color: #00cdbc;
    }
    h5 {
      color: #FF1744;
      font-size: 18px;
    }
    i {
      // float: left;
      height: 32px;
      top: 50%;
      margin-top: -16px;
      left: -50px;
      position: absolute;
      color: #FF1744;
      font-size: 32px;
      &:nth-of-type(2) {
        left: unset;
        top: unset;
        margin-top: 0 !important;
        height: unset;
        cursor: pointer;
        font-size: 18px;
        bottom: 10px;
        right: -10px;
      }
    }
    // background: rgba(0, 0, 0, 0.2);

    .inputContainer {
      margin: 5px 0;
      label {
        display: block;
        // color: #FF1744;
        font-size: 14px;
        font-weight: 900;
      }
      input {
        width: 100%;
        appearance: none;
        border: none;
        outline: none;
        display: block;
        font-size: 14px;
        color: #111;
        font-weight: normal;
        background-color: #e7e7e7;
        // background-color: #eee;
        margin: 0;
        padding: 10px 10px;
        border-radius: 10px;
        resize: none;
        height: 50px;
      }
      textarea {
        width: 100%;
        appearance: none;
        border: none;
        outline: none;
        display: block;
        font-size: 14px;
        color: #111;
        font-weight: normal;
        background-color: #eee;
        margin: 0;
        padding: 10px 10px;
        border-radius: 10px;
        resize: none;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .loginFormContainer {
    margin-left: 0;
    width: 90%;
    height: 270px;
    padding: 15px;
    margin-top: -20vh;
    border-radius: 0;
  }

  @media (orientation: landscape) {
    .loginFormContainer {
      max-width: 30vw !important;
    }
  }
  .sideBar {
    width: 0 !important;
    & * {
      display: none !important;
    }
  }
}
.loginFooter {
  position: absolute;
  padding-right: 5vw;
  bottom: 20px;
  width: 100%;
  text-align: right;
}
.sideBar {
  color: white;
  position: absolute;
  box-sizing: border-box;
  padding: 30px 30px 20px;
  top: 0;
  left: 0;
  height: 100vh;
  width: 35vw;
  background-color: #FF1744;
  filter: drop-shadow(0px 0px 30px rgba(#FF1744, 0.8));
  // opacity: 1;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    text-align: left;
    margin-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 120%;
    right: 0;
    top: 0;
    transform: rotate(-4deg);
    transform-origin: top right;
    background: #FF1744;
    z-index: -1;
  }
  &::after {
    //to prevent overbounce when appear
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: -50%;
    top: 0;
    background: #FF1744;
    z-index: -1;
  }
  h1 {
    font-size: 32px;
    margin: 20px 5px;
  }
  svg {
    width: 150px;
    path {
      fill: white;
    }
  }
  img.pulposo {
    width: 122%;
    position: absolute;
    bottom: 0;
    left: 10px;
  }
  button.closePanel {
    appearance: none;
    border: none;
    outline: none;
    // background-color: #00cdbc;
    font-weight: bold;
    color: white;
    text-decoration: none;
    // color: #00cdbc;
    margin: 0 5px;
    // background-color: #eee;
    box-sizing: content-box;
    text-align: center;
    padding: 5px;
    width: 32px;
    height: 32px;
    border-radius: 18px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 10px;
    left: -32px;
    transition: 0.3s all;
    color: white;
    background-color: #FF1744;
    box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
    &.inactive {
      background-color: #aaa;
      box-shadow: 0px 0px 20px rgba(#333, 0.2);
    }
    i {
      font-size: 21px;
    }
  }
  h2.title {
    font-weight: 900;
    font-size: 32px;
    color: #00cdbc;
  }
  .subTitle {
    font-size: 14px;
    height: 50px;
    color: #888;
    display: block;
    text-align: right;
    font-style: italic;
    &::after {
      content: ".";
    }
  }
}
</style>